import {Category, DefaultService} from "app/lib/api";
import {Injectable} from "@angular/core";

@Injectable()
export class CategoryCloud {
  constructor(private apiClient: DefaultService) {

  }

  get(categoryId) {
    return this.apiClient.categoryEndpointV1Get(categoryId)
  }

  list(limit, cursor) {
    return this.apiClient.categoryEndpointV1List(limit, cursor)
  }

  save(category: Category) {
    return this.apiClient.categoryEndpointV1Save(category)
  }
}
